/* Sinneszauber Duft-Mixer
   Vier Stufen pro Duftrichtung (Nein / Neutral / Gerne / Unbedingt, bis 16.10.2026: Nein / Egal / Gern / Sehr gern). Produkte werden
   nach ihrer Duftpyramide gefiltert und sortiert. Ben\u00f6tigt notes.js. */
(function () {
  const FAMILIES = [
    { id: 'frisch', thumb: 'zitrone', label: 'Frisch', hint: 'Zitrus, Meer, Kr\u00e4uter', color: '#E2B21C',
      keys: ['bergamotte', 'mandarine', 'orange', 'zitrone', 'limette', 'grapefruit', 'meer', 'minze', 'tee', 'lavendel', 'basilikum', 'rosmarin', 'salbei'] },
    { id: 'fruchtig', thumb: 'himbeere', label: 'Fruchtig', hint: 'Beeren, Pfirsich, Birne', color: '#C2284A',
      keys: ['johannisbeere', 'himbeere', 'brombeere', 'erdbeere', 'pfirsich', 'aprikose', 'litschi', 'pflaume', 'apfel', 'birne', 'ananas', 'melone'] },
    { id: 'blumig', thumb: 'rose', label: 'Blumig', hint: 'Rose, Jasmin, Iris', color: '#C46A8C',
      keys: ['rose', 'pfingstrose', 'jasmin', 'orangenbluete', 'tuberose', 'ylang', 'osmanthus', 'veilchen', 'iris', 'lilie', 'gardenie', 'maigloeckchen', 'magnolie', 'freesie', 'heliotrop', 'geranie'] },
    { id: 'suess', thumb: 'vanille', label: 'S\u00fc\u00df', hint: 'Vanille, Tonka, Kaffee', color: '#B0702A',
      keys: ['vanille', 'tonka', 'kaffee', 'kakao', 'karamell', 'honig', 'mandel', 'kokos', 'lakritz'] },
    { id: 'wuerzig', thumb: 'zimt', label: 'W\u00fcrzig', hint: 'Pfeffer, Zimt, Kardamom', color: '#9A4A22',
      keys: ['zimt', 'rosapfeffer', 'pfeffer', 'kardamom', 'ingwer', 'muskat', 'safran', 'koriander', 'anis'] },
    { id: 'holzig', thumb: 'zeder', label: 'Holzig', hint: 'Sandelholz, Zeder, Vetiver', color: '#6A4A2E',
      keys: ['guajak', 'zeder', 'sandelholz', 'vetiver', 'oud', 'patschuli', 'moos', 'leder'] },
    { id: 'orientalisch', thumb: 'ambra', label: 'Orientalisch', hint: 'Ambra, Harze, Moschus', color: '#D9861A',
      keys: ['ambra', 'moschus', 'weihrauch', 'benzoe'] },
  ];
  const STEPS = ['Nein', 'Neutral', 'Gerne', 'Unbedingt'];
  const WEIGHT = [0, 0, 1, 2.5];
  const PRESETS = [
    { label: 'Zitrisch', v: { frisch: 3, fruchtig: 2, suess: 0, orientalisch: 0 } },
    { label: 'Aquatisch', v: { frisch: 3, holzig: 2, suess: 0, orientalisch: 0 } },
    { label: 'Floral', v: { blumig: 3, fruchtig: 2, holzig: 0 } },
    { label: 'Pudrig', v: { blumig: 3, suess: 2, orientalisch: 2, frisch: 0 } },
    { label: 'W\u00fcrzig & Holzig', v: { wuerzig: 3, holzig: 3, orientalisch: 1, fruchtig: 0 } },
    { label: 'Ledrig', v: { holzig: 3, wuerzig: 2, orientalisch: 2, fruchtig: 0, blumig: 0 } },
  ];
  const LEVEL_W = { Kopfnote: 1, Herznote: 1.2, Basisnote: 1.2 };
  const NO_LIMIT = 45; // ab diesem Anteil gilt eine Richtung als "deutlich drin"
  const fmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });

  function profile(notesText) {
    const notes = window.SZNotes.parse(notesText);
    const p = {};
    FAMILIES.forEach((f) => (p[f.id] = 0));
    notes.forEach((n) => {
      const fam = FAMILIES.find((f) => f.keys.includes(n.key));
      if (fam) p[fam.id] += LEVEL_W[n.level] || 1;
    });
    const max = Math.max(...Object.values(p));
    if (max > 0) for (const k in p) p[k] = Math.round((p[k] / max) * 100);
    return { p, list: notes, has: max > 0 };
  }

  // Ergebnis: null = ausgeblendet, sonst 0..1
  function score(steps, p) {
    for (const f of FAMILIES) if (steps[f.id] === 0 && p[f.id] >= NO_LIMIT) return null;
    let sum = 0, w = 0;
    for (const f of FAMILIES) { const k = WEIGHT[steps[f.id]]; sum += k * p[f.id]; w += k; }
    if (!w) {
      // nur "Nein" gew\u00e4hlt: je weniger von den abgew\u00e4hlten Richtungen, desto besser
      const no = FAMILIES.filter((f) => steps[f.id] === 0);
      return no.length ? 1 - no.reduce((a, f) => a + p[f.id], 0) / (no.length * 100) : 0;
    }
    return sum / (w * 100);
  }
  const LEVELS = ['leicht', 'mittel', 'stark'];
  // Etikett "S\u00fc\u00df \u25cf\u25cf\u25cb" in der Farbe der Duftrichtung
  function tag(f, v) {
    const n = v >= 67 ? 3 : v >= 34 ? 2 : 1;
    return `<span class="mx-tag" style="--fam:${f.color}" title="${f.label}: ${LEVELS[n - 1]}">${f.label} <i aria-hidden="true">${'\u25cf'.repeat(n)}<b>${'\u25cf'.repeat(3 - n)}</b></i><span class="visually-hidden"> ${LEVELS[n - 1]}</span></span>`;
  }
  function tags(notesText, max) {
    const pr = profile(notesText);
    if (!pr.has) return '';
    return FAMILIES.filter((f) => pr.p[f.id] > 0).sort((a, b) => pr.p[b.id] - pr.p[a.id]).slice(0, max || 7).map((f) => tag(f, pr.p[f.id])).join('');
  }
  const verdict = (s) => (s >= 0.7 ? 'Top-Treffer' : s >= 0.45 ? 'Passt gut' : 'Passt etwas');

  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  // "105 - Espresso - Unisexparf\u00fcm | 3105 | C105" -> Name + Codes
  function splitTitle(t) {
    const parts = t.split('|').map((s) => s.trim()).filter(Boolean);
    return { name: parts[0] || t, codes: parts.slice(1).join(' \u00b7 ') };
  }


  // Grundpreis je 100 ml aus dem Variantennamen ("70ml", "Duschgel 250ml")
  function mlOf(title) {
    const m = String(title || '').match(/(\d+(?:[.,]\d+)?)\s*ml\b/i);
    return m ? parseFloat(m[1].replace(',', '.')) : 0;
  }
  function unit(title, price) {
    const ml = mlOf(title);
    if (!ml || !price) return '';
    return fmt.format((Number(price) / ml) * 100) + ' / 100 ml';
  }
  // Mengenvorteil: Ersparnis pro ml gegen\u00fcber der kleinsten Flakongr\u00f6\u00dfe (ab 10 ml)
  const pureMl = (t) => /^\s*\d+(?:[.,]\d+)?\s*ml\s*$/i.test(String(t || ''));
  function savePct(vs, v) {
    if (!pureMl(v.title)) return 0;
    const base = vs.filter((x) => pureMl(x.title) && mlOf(x.title) >= 10).sort((a, b) => mlOf(a.title) - mlOf(b.title))[0];
    if (!base || mlOf(v.title) <= mlOf(base.title)) return 0;
    const pct = Math.round((1 - (v.price / mlOf(v.title)) / (base.price / mlOf(base.title))) * 100);
    return pct >= 5 ? pct : 0;
  }
  // Gr\u00f6\u00dfen-Pills (Produktseite): "70ml \u00b7 45,00 \u20ac" -> Spar-Hinweis anh\u00e4ngen
  function savePills(root) {
    (root || document).querySelectorAll('.pills').forEach((box) => {
      const vs = [...box.querySelectorAll('label span')].map((s) => {
        const m = s.textContent.match(/^(.*?)\s*\u00b7\s*([\d.]+,\d{2})/);
        return m ? { el: s, title: m[1], price: Number(m[2].replace(/\./g, '').replace(',', '.')) } : null;
      }).filter(Boolean);
      vs.forEach((v) => { const p = savePct(vs, v); if (p && !v.el.querySelector('.mx-save')) v.el.insertAdjacentHTML('beforeend', ` <b class="mx-save">${p} % g\u00fcnstiger pro ml</b>`); });
    });
  }
  // Bestseller laut Top-10-Listen der Testkits (window.SZ.best), Neuheiten der letzten 30 Tage
  const numOf = (title) => { const m = String(title || '').trim().match(/^0*(\d{1,3})\s*[-\u2013|]/); return m ? Number(m[1]) : null; };
  const isBest = (p) => { const n = numOf(p.title); return n != null && ((window.SZ && SZ.best) || []).includes(n); };
  const isNew = (p) => !!p.created && Date.now() - new Date(p.created).getTime() < 30 * 864e5;
  function badges(p) {
    if (/testerkit|kennlernset/i.test(p.handle || '')) return '';
    const b = [/luxury/i.test(p.title || '') ? '<span class="sz-badge is-lux">\u2726 Luxury</span>' : '', isNew(p) ? '<span class="sz-badge is-new">Neu</span>' : '', isBest(p) ? '<span class="sz-badge is-best">Bestseller</span>' : ''].join('');
    return b ? `<span class="sz-badges">${b}</span>` : '';
  }
  const HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20s-7-4.4-9.2-8.6C1.2 8.3 3 5 6.3 5c2 0 3.2 1 3.7 2.1C10.5 6 11.7 5 13.7 5 17 5 18.8 8.3 17.2 11.4 15 15.6 12 20 12 20Z" transform="translate(1.3 0)"/></svg>';
  function wishBtn(p) {
    const h = p.handle || '';
    if (!h) return '';
    return `<button type="button" class="wish" data-wish="${esc(h)}" data-title="${esc(splitTitle(p.title).name)}" data-url="${esc(p.url)}" data-image="${esc(p.image || '')}" data-price="${p.priceMin}" aria-pressed="false" aria-label="${esc(splitTitle(p.title).name)} auf die Merkliste">${HEART}</button>`;
  }

  // Variantenname ausgeschrieben, nur Leerzeichen vor ml vereinheitlicht (14.10.2026)
  // Einheiten einheitlich mit Leerzeichen: 30 ml, 1 kg, 1000 g (16.10.2026)
  const fullSize = (t) => String(t).replace(/(\d)\s*(ml|kg|g)\b/gi, (m, d, u) => d + ' ' + u.toLowerCase()).replace(/\s+/g, ' ').trim();
  const shortSize = (t) => {
    const x = String(t).replace(/(\d)\s*ml/gi, '$1 ml').replace(/\s*\(.*?\)\s*/g, ' ').trim();
    if (/duschgel/i.test(x)) return 'Duschgel';
    if (/k\u00f6rper|lotion|creme/i.test(x)) return x.split(' ')[0];
    return x.length > 14 ? x.slice(0, 13) + '\u2026' : x;
  };
  // Standardgr\u00f6\u00dfe: 30 ml, sonst die kleinste Flakongr\u00f6\u00dfe \u00fcber 3 ml, sonst die erste verf\u00fcgbare
  function defaultVariant(vs) {
    const ok = vs.filter((v) => v.available !== false);
    return ok.find((v) => mlOf(v.title) === 30)
      || ok.filter((v) => mlOf(v.title) > 3 && !/duschgel|k\u00f6rper|haar/i.test(v.title)).sort((a, b) => mlOf(a.title) - mlOf(b.title))[0]
      || ok[0] || null;
  }
  function renderCard(p, opts = {}) {
    const t = splitTitle(p.title);
    const top = FAMILIES.filter((f) => p.p[f.id] > 0).sort((a, b) => p.p[b.id] - p.p[a.id]).slice(0, 2);
    const vs = (p.variants || []).filter(Boolean);
    const multi = vs.length > 1;
    const def = multi ? defaultVariant(vs) : vs[0] || null;
    const shownPrice = def ? def.price : p.priceMin;
    // Groesse auch bei nur einer Variante zeigen (z. B. 750ml), ausser Shopifys "Default Title" (16.10.2026)
    const realSize = (v) => !!v && !/^default title$/i.test(String(v.title).trim());
    const size = (multi || realSize(vs[0])) ? `<div class="mx-sizes" role="radiogroup" aria-label="Gr\u00f6\u00dfe f\u00fcr ${esc(t.name)}">
        ${vs.map((v) => `<button type="button" class="mx-sz" role="radio" aria-checked="${def && v.id === def.id}" data-v="${v.id}" data-price="${v.price}" data-unit="${esc(unit(v.title, v.price))}" data-label="${esc(shortSize(v.title))}" title="${esc(v.title)} \u00b7 ${fmt.format(v.price)}" ${v.available === false ? 'disabled' : ''}>${esc(fullSize(v.title))}</button>`).join('')}
      </div>` : '';
    const buy = p.available === false
      ? `<button type="button" class="mx-add" disabled>Ausverkauft</button>`
      : `<button type="button" class="mx-add${multi && !def ? ' needs-size' : ''}" data-variant="${def ? def.id : (multi ? '' : p.variantId)}">${multi && !def ? 'Gr\u00f6\u00dfe w\u00e4hlen' : 'In den Warenkorb'}</button>`;
    // Interner Link wie in der Merkliste, damit kein zweiter Tab mit dem Live-Shop aufgeht (14.10.2026)
    const link = window.SZPreview ? '#p-' + p.handle : p.url;
    return `<article class="mx-card${multi ? ' has-sizes' : ''}${/luxury/i.test(p.title || '') ? ' is-lux' : ''}">
      ${wishBtn(p)}
      <a class="mx-media" href="${esc(link)}" ${opts.external ? 'target="_blank" rel="noopener"' : ''} data-notes="${esc(p.notes)}" data-max="3">
        ${p.image ? `<img src="${esc(p.image)}" alt="${esc(t.name)}" loading="lazy">` : ''}
        ${badges(p)}
        ${p.match != null ? `<span class="mx-match${p.match >= 0.7 ? ' is-top' : ''}">${verdict(p.match)}</span>` : ''}
      </a>
      <div class="mx-info">
        <a href="${esc(link)}" ${opts.external ? 'target="_blank" rel="noopener"' : ''} class="mx-name" title="${esc(t.codes)}">${esc(t.name)}</a>
        <div class="mx-swap">
          <div class="mx-tags">${top.map((f) => tag(f, p.p[f.id])).join('')}</div>
          ${size}
        </div>
        <div class="mx-buy">
          <span class="mx-price-wrap">
            ${multi ? `<button type="button" class="mx-size-toggle" aria-expanded="false">${def ? esc(shortSize(def.title)) : 'Gr\u00f6\u00dfe'} <span aria-hidden="true">\u25be</span></button>` : ''}
            <span class="mx-price">${fmt.format(shownPrice)}</span>
            <span class="mx-unit">${def ? esc(unit(def.title, def.price)) : ''}</span>
          </span>
          ${buy}
        </div>
      </div>
    </article>`;
  }

  function pickSize(chip) {
    const card = chip.closest('.mx-card');
    card.querySelectorAll('.mx-sz').forEach((c) => c.setAttribute('aria-checked', c === chip));
    const btn = card.querySelector('.mx-add');
    btn.dataset.variant = chip.dataset.v;
    btn.textContent = 'In den Warenkorb';
    btn.classList.remove('needs-size');
    card.querySelector('.mx-price').textContent = fmt.format(Number(chip.dataset.price));
    const tg = card.querySelector('.mx-size-toggle');
    if (tg) tg.firstChild.textContent = (chip.dataset.label || chip.textContent) + ' ';
    const u = card.querySelector('.mx-unit');
    if (u) u.textContent = chip.dataset.unit || '';
    card.querySelector('.mx-sizes').classList.remove('is-missing');
  }
  function bindGrid(grid, opts = {}) {
    if (grid.dataset.bound) return;
    grid.dataset.bound = '1';
    grid.addEventListener('click', (e) => {
      const tg = e.target.closest('.mx-size-toggle');
      if (tg) {
        const card = tg.closest('.mx-card');
        const open = !card.classList.contains('is-open');
        grid.querySelectorAll('.mx-card.is-open').forEach((c) => { c.classList.remove('is-open'); const t = c.querySelector('.mx-size-toggle'); t && t.setAttribute('aria-expanded', 'false'); });
        card.classList.toggle('is-open', open);
        tg.setAttribute('aria-expanded', open);
        return;
      }
      const chip = e.target.closest('.mx-sz');
      if (chip && !chip.disabled) { pickSize(chip); return; }
      const b = e.target.closest('button.mx-add');
      if (!b || b.disabled) return;
      if (!b.dataset.variant) {
        const box = b.closest('.mx-card').querySelector('.mx-sizes');
        if (box) { box.classList.remove('is-missing'); void box.offsetWidth; box.classList.add('is-missing'); const first = box.querySelector('.mx-sz:not([disabled])'); first && first.focus(); }
        return;
      }
      if (opts.onAdd) opts.onAdd(b.dataset.variant, b);
    });
  }

  // Aehnliche Duefte ueber die Duftpyramide (Kosinus-Aehnlichkeit der Duftprofile)
  function similar(products, notesText, n = 4, exclude = '') {
    const a = profile(notesText || '');
    if (!a.has) return [];
    const dot = (x, y) => FAMILIES.reduce((s, f) => s + x[f.id] * y[f.id], 0);
    const norm = (x) => Math.sqrt(dot(x, x)) || 1;
    return products
      .filter((q) => q.handle !== exclude && q.notes)
      .map((q) => ({ ...q, ...profile(q.notes) }))
      .filter((q) => q.has)
      .map((q) => ({ ...q, sim: dot(a.p, q.p) / (norm(a.p) * norm(q.p)) }))
      .sort((x, y) => y.sim - x.sim)
      .slice(0, n);
  }
  function renderSimilar(el, products, notesText, opts = {}) {
    const list = similar(products, notesText, opts.n || 4, opts.exclude);
    if (!list.length) return false;
    el.classList.add('mx-grid');
    el.innerHTML = list.map((p) => renderCard(p, opts)).join('');
    bindGrid(el, opts);
    if (window.SZNotes) window.SZNotes.init(el);
    if (window.SZWish) window.SZWish.sync(el);
    return true;
  }

  function mount(root, products, opts = {}) {
    const limit = Number(root.dataset.limit || opts.limit || 24);
    const groups = [...new Set(products.flatMap((p) => p.groups || []))];
    const items = products.map((p) => ({ ...p, ...profile(p.notes || '') })).filter((p) => p.has);
    const state = { s: {}, group: 'Alle', shown: limit, sort: 'match' };
    FAMILIES.forEach((f) => (state.s[f.id] = 1));
    const base = (window.SZ && SZ.noteBase) || 'notes/';

    root.innerHTML = `
      <div class="mx-status" aria-live="polite"></div>
      <div class="mx-panel">
        <div class="mx-sliders">
          ${FAMILIES.map((f) => `
            <div class="mx-row" style="--fam:${f.color}">
              <label for="mx-${f.id}"><span>${f.label}<small>${f.hint}</small></span><output id="mx-o-${f.id}">Neutral</output></label>
              <div class="mx-track mx-steps"><div class="mx-fill"></div><i class="mx-stop" style="left:0"></i><i class="mx-stop" style="left:33.333%"></i><i class="mx-stop" style="left:66.666%"></i><i class="mx-stop" style="left:100%"></i>
                <input type="range" id="mx-${f.id}" min="0" max="3" step="1" value="1" data-fam="${f.id}" style="--thumb:url('${base}thumb-${f.id}.png')" aria-label="${f.label}" aria-valuetext="Neutral">
              </div>
            </div>`).join('')}
          <div class="mx-ticks mx-step-ticks" aria-hidden="true"><span>Nein</span><span>Neutral</span><span>Gerne</span><span>Unbedingt</span></div>
        </div>
        <div class="mx-side">
          <p class="mx-eyebrow">Schnellauswahl</p>
          <div class="mx-presets">${PRESETS.map((p, i) => `<button type="button" class="mx-chip" data-preset="${i}">${p.label}</button>`).join('')}</div>
          ${groups.length > 1 ? `<p class="mx-eyebrow">F\u00fcr wen</p><div class="mx-groups">${['Alle', ...groups].map((g) => `<button type="button" class="mx-chip${g === 'Alle' ? ' is-on' : ''}" data-group="${esc(g)}">${esc(g)}</button>`).join('')}</div>` : ''}
          <p class="mx-hint">Tipp: Mit <strong>Nein</strong> blendest du Richtungen aus, die du nicht magst.</p>
          <button type="button" class="mx-reset"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v5h5"/></svg>Alles zur\u00fccksetzen</button>
        </div>
      </div>
      <div class="toolbar mx-toolbar"><span class="mx-sort-hint" aria-hidden="true"></span><label>Sortieren <select class="mx-sort" aria-label="Ergebnisse sortieren">
        <option value="match">Beste Treffer</option><option value="new">Neueste</option><option value="asc">Preis aufsteigend</option><option value="desc">Preis absteigend</option><option value="az">Alphabetisch A\u2013Z</option>
      </select></label></div>
      <div class="mx-grid"></div>
      <div class="mx-more-wrap"><button type="button" class="mx-more btn ghost">Mehr D\u00fcfte zeigen</button></div>`;

    const grid = root.querySelector('.mx-grid');
    const status = root.querySelector('.mx-status');
    const more = root.querySelector('.mx-more');
    const sortSel = root.querySelector('.mx-sort');
    sortSel.addEventListener('change', () => { state.sort = sortSel.value; state.shown = limit; update(); });
    const inputs = [...root.querySelectorAll('input[type=range]')];

    function paint(inp) {
      const v = Number(inp.value);
      const track = inp.parentElement;
      track.style.setProperty('--v', v >= 2 ? (v / 3) * 100 + '%' : '0%');
      track.classList.toggle('is-no', v === 0);
      track.classList.toggle('is-max', v === 3);
      inp.setAttribute('aria-valuetext', STEPS[v]);
      const out = root.querySelector('#mx-o-' + inp.dataset.fam);
      out.textContent = STEPS[v];
      out.dataset.step = v;
    }

    const card = (p) => renderCard(p, opts);

    function update() {
      const vals = Object.values(state.s);
      const active = vals.some((v) => v !== 1);
      const likes = vals.some((v) => v >= 2);
      let list = items.filter((p) => state.group === 'Alle' || (p.groups || []).includes(state.group));
      if (active) {
        list = list.map((p) => ({ ...p, match: score(state.s, p.p) }))
          .filter((p) => p.match !== null && (!likes || p.match >= 0.2))
          .sort((a, b) => b.match - a.match);
        if (!likes) list = list.map((p) => ({ ...p, match: null }));
      } else {
        list = list.map((p) => ({ ...p, match: null }));
      }
      // Sortierung (16.10.2026): "Beste Treffer" laesst die Reihenfolge des Mixers stehen
      const nm = (p) => splitTitle(p.title || '').name;
      // nach dem Preis sortieren, der auf der Karte steht (vorausgewaehlte Groesse, meist 30 ml)
      const pr = (p) => { const vs = (p.variants || []).filter(Boolean); const d = vs.length > 1 ? defaultVariant(vs) : vs[0]; return d ? Number(d.price) : Number(p.priceMin) || 0; };
      if (state.sort === 'asc') list.sort((a, b) => pr(a) - pr(b));
      else if (state.sort === 'desc') list.sort((a, b) => pr(b) - pr(a));
      else if (state.sort === 'az') list.sort((a, b) => nm(a).localeCompare(nm(b), 'de', { numeric: true }));
      else if (state.sort === 'new') list.sort((a, b) => String(b.created || '').localeCompare(String(a.created || '')));
      const total = list.length;
      const noNames = FAMILIES.filter((f) => state.s[f.id] === 0).map((f) => f.label);
      status.innerHTML = active
        ? `<strong>${total}</strong> ${total === 1 ? 'Duft passt' : 'D\u00fcfte passen'} zu deiner Auswahl${noNames.length ? ` \u00b7 ohne ${noNames.join(', ')}` : ''}`
        : `<strong>${total}</strong> D\u00fcfte \u00b7 Stell ein, was du magst und was nicht`;
      const promo = typeof opts.promo === 'function' ? opts.promo() : (opts.promo || '');
      grid.innerHTML = total
        ? promo + list.slice(0, state.shown).map(card).join('')
        : `<p class="mx-empty">F\u00fcr diese Auswahl haben wir gerade keinen Treffer. Stell eine Richtung von \u201eNein\u201c auf \u201eNeutral\u201c oder probier eine Schnellauswahl.</p>`;
      more.hidden = total <= state.shown;
      if (window.SZNotes) window.SZNotes.init(grid);
      if (window.SZWish) window.SZWish.sync(grid);
    }

    inputs.forEach((inp) => {
      paint(inp);
      inp.addEventListener('input', () => {
        state.s[inp.dataset.fam] = Number(inp.value);
        state.shown = limit;
        paint(inp);
        update();
      });
    });
    // Klick auf die Stufen-Beschriftung unter den Reglern ist nicht noetig; Tippen auf die Schiene springt direkt.
    root.querySelectorAll('[data-preset]').forEach((b) => b.addEventListener('click', () => {
      const v = PRESETS[b.dataset.preset].v;
      inputs.forEach((inp) => {
        inp.value = v[inp.dataset.fam] != null ? v[inp.dataset.fam] : 1;
        state.s[inp.dataset.fam] = Number(inp.value);
        paint(inp);
      });
      root.querySelectorAll('[data-preset]').forEach((x) => x.classList.toggle('is-on', x === b));
      state.shown = limit;
      update();
    }));
    root.querySelectorAll('[data-group]').forEach((b) => b.addEventListener('click', () => {
      root.querySelectorAll('[data-group]').forEach((x) => x.classList.toggle('is-on', x === b));
      state.group = b.dataset.group;
      state.shown = limit;
      update();
    }));
    root.querySelector('.mx-reset').addEventListener('click', () => {
      inputs.forEach((inp) => { inp.value = 1; state.s[inp.dataset.fam] = 1; paint(inp); });
      root.querySelectorAll('[data-preset]').forEach((x) => x.classList.remove('is-on'));
      // "Alles zur\u00fccksetzen" (17.10.2026): auch "F\u00fcr wen" auf Alle und die Sortierung auf Beste Treffer
      state.group = 'Alle';
      root.querySelectorAll('[data-group]').forEach((x) => x.classList.toggle('is-on', x.dataset.group === 'Alle'));
      state.sort = 'match'; sortSel.value = 'match';
      state.shown = limit;
      update();
    });
    more.addEventListener('click', () => { state.shown += limit; update(); });
    bindGrid(grid, opts);
    update();
  }

  // Shopify: Produkte der gew\u00e4hlten Kollektionen \u00fcber die \u00f6ffentliche JSON-API laden
  async function fromCollections(sources) {
    const key = 'sz-col:' + sources.map((x) => x.handle + (x.label ? '=' + x.label : '')).join(',');
    try {
      const c = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (c && Date.now() - c.t < 6e5) return c.d;
    } catch (_) {}
    const d = await loadCollections(sources);
    try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), d })); } catch (_) {}
    return d;
  }
  async function loadCollections(sources) {
    const byHandle = new Map();
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    // alle Kollektionen gleichzeitig laden, danach in fester Reihenfolge zusammenf\u00fchren
    const lists = await Promise.all(sources.map(async (src) => {
      const all = [];
      for (let page = 1; page < 6; page++) {
        const r = await fetch(`${root}collections/${src.handle}/products.json?limit=250&page=${page}`);
        if (!r.ok) break;
        const { products } = await r.json();
        all.push(...products);
        if (products.length < 250) break;
      }
      return { src, products: all };
    }));
    for (const { src, products } of lists) {
        products.forEach((p) => {
          const prices = p.variants.map((v) => Number(v.price));
          const entry = byHandle.get(p.handle) || {
            handle: p.handle,
            title: p.title,
            url: `${(window.Shopify && Shopify.routes && Shopify.routes.root) || '/'}products/${p.handle}`,
            image: p.images[0] ? p.images[0].src + (p.images[0].src.includes('?') ? '&' : '?') + 'width=500' : '',
            notes: (p.body_html || '').replace(/<[^>]+>/g, ' '),
            variantId: (p.variants.find((v) => v.available) || p.variants[0]).id,
            variants: p.variants.map((v) => ({ id: v.id, title: v.title, price: Number(v.price), available: v.available })),
            available: p.variants.some((v) => v.available),
            priceMin: Math.min(...prices),
            priceMax: Math.max(...prices),
            created: p.created_at || p.published_at || '',
            groups: [],
          };
          if (src.label && !entry.groups.includes(src.label)) entry.groups.push(src.label);
          byHandle.set(p.handle, entry);
        });
    }
    return [...byHandle.values()];
  }

  window.SZMixer = { defaultVariant, savePct, savePills, badges, isBest, isNew, mount, fromCollections, profile, tags, unit, mlOf, similar, renderSimilar, renderCard, bindGrid, FAMILIES, STEPS };
})();
